import AppConfig from "../../../../config/AppConfig";

export default {
  login: {
    data: [AppConfig.API_URL + "/anim?intro_login"],
    loop: [false],
  },
};
